import { computed, ref, ComputedRef } from 'vue'
import { useApi } from '@/composables/useApi'

export type InvoiceStatus = {
    [key: string]: string | number
    id: number
    symbol: string
    name: string
}

const isLoading = ref<boolean>(false)
const invoiceStatuses = ref<InvoiceStatus[]>([])
const isEmpty = computed(() => invoiceStatuses.value.length === 0)

export const useInvoiceStatuses = (): {
    fetchInvoiceStatuses: () => Promise<void>
    invoiceStatuses: ComputedRef<InvoiceStatus[]>
    isLoading: ComputedRef<boolean>
    isEmpty: ComputedRef<boolean>
} => {
    const { useGet } = useApi()

    async function fetchInvoiceStatuses(): Promise<void> {
        if (!isEmpty.value) return

        isLoading.value = true
        try {
            const { status, data } = await useGet('/invoice-statuses')
            if (status === 200 && data.data) {
                invoiceStatuses.value = data.data
            }
        } finally {
            isLoading.value = false
        }
    }

    return {
        fetchInvoiceStatuses,
        invoiceStatuses: computed(() => invoiceStatuses.value),
        isLoading: computed(() => isLoading.value),
        isEmpty,
    }
}
